var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('EstimateRow',{staticClass:"estimate-header"},_vm._l((_vm.fields),function(field){return _c('div',{key:field,staticClass:"text-center"},[_vm._v("\n    "+_vm._s(field)+"\n  ")])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }